import type { Rect } from '../../engine/hex/types';
import type { ModalTheme } from './ModalTheme';
import type { HitTarget, UiItem } from './items';
import type { IconRegistry } from '../../ui/overlay/assets/IconRegistry';

export type FlowLayoutResult = {
    contentHeight: number;
};

export function flowMeasureAndLayout(
    ctx: CanvasRenderingContext2D,
    items: UiItem[],
    contentRect: Rect,
    theme: ModalTheme,
): FlowLayoutResult {
    let cy = contentRect.y;
    items.forEach((item, index) => {
        const size = item.measure(ctx, contentRect.w, theme);
        item.layout(contentRect.x, cy, contentRect.w, theme);
        cy += size.h + (index < items.length - 1 ? theme.spacing.itemGap : 0);
    });
    const contentHeight = Math.max(0, cy - contentRect.y);
    return { contentHeight };
}

export function flowRender(
    ctx: CanvasRenderingContext2D,
    opts: {
        items: UiItem[];
        contentRect: Rect;
        scrollY: number;
        theme: ModalTheme;
        hitTargetsOut: HitTarget[];
        icons?: IconRegistry;
    },
): void {
    const { items, contentRect, scrollY, theme, hitTargetsOut, icons } = opts;
    ctx.save();
    ctx.beginPath();
    ctx.rect(contentRect.x, contentRect.y, contentRect.w, contentRect.h);
    ctx.clip();
    ctx.translate(0, -scrollY);
    items.forEach((item) => item.draw(ctx, theme, icons));
    ctx.restore();

    items.forEach((item) => item.collectHitTargets(hitTargetsOut, scrollY));
}
